<div>
  <a class="layout-menu-item" href="#" (click)="onItemClick($event)" [class.active]="isActive()">
    <i class="layout-menu-item-icon" [ngClass]="item.icon"></i>
    <span class="layout-menu-item-label" [ngClass]="labelClass">{{ item.label }}</span>
    <span *ngIf="item.badge" class="layout-menu-item-badge">{{ item.badge }}</span>
  </a>
</div>
